import { AppRoutes } from '@/constants';
import { navigate } from '@/providers';

import { Button } from '@/components/common';
import { Alert } from '@/lib/ui';

import { ServerErrorIcon } from '@/assets/icons';

export const InternalError = ({
  errorMessage = 'Internal Server Error',
}: {
  errorMessage?: string;
}) => {
  const copyMessage = async () => {
    await navigator.clipboard.writeText(errorMessage);
    Alert.success('Message copied to clipboard!');
  };

  return (
    <div className="h-full flex flex-col items-center justify-center bg-transparent overflow-y-auto">
      <ServerErrorIcon className="flex-shrink-0" />
      <h1 className="text-[32px] font-bold text-primary-darkest mt-10 mb-3 text-center">
        Uh...Oh...! Something Went Wrong
      </h1>
      <span className="font-medium text-base text-neutral-7 text-center">
        Please reload the page or copy the error message and send an email to <br /> our
        Administrator via <u>admin@stengg.com</u>
      </span>
      <div className="text-base font-medium text-neutral-7 border border-solid border-neutral-5 bg-neutral-3 text-center my-6 mx-8 p-5 rounded-xs h-auto">
        {errorMessage}
      </div>
      <div className="flex items-center flex-wrap justify-center gap-3">
        <Button
          buttonStyle="filled"
          buttonColor="primary"
          size="lg"
          className="w-[208px]"
          onClick={() => navigate(AppRoutes.HOME)}
        >
          Reload Page
        </Button>
        <Button
          buttonStyle="outline"
          buttonColor="primary"
          size="lg"
          className="w-[208px]"
          onClick={copyMessage}
        >
          Copy Message
        </Button>
      </div>
    </div>
  );
};
